import { useContext } from 'react';
import { ModalContext } from '../contexts/modal/helpers';

const useModal = () => useContext(ModalContext);

export default useModal;
